import Info from 'core/components/validatedForm/Info'
import ListTableField from 'core/components/validatedForm/ListTableField'
import Text from 'core/elements/Text'
import { useMemo } from 'react'
import { filterAvailableCreateVmVolumes } from '../CreateVirtualMachineModal.helpers'
import useCreateVirtualMachineModalStyles from '../CreateVirtualMachineModal.styles'
import { volumeColumns } from '../helpers'

interface Props {
  availableVolumesRaw: any[]
  getParamsUpdater: any
  loadingAvailableVolumes: boolean
  params: any
  reloadAvailableVolumes: () => void
  updatingAvailableVolumes: boolean
}

export default function CreateVirtualMachineAttachVolumesStep({
  availableVolumesRaw,
  getParamsUpdater,
  loadingAvailableVolumes,
  params,
  reloadAvailableVolumes,
  updatingAvailableVolumes,
}: Props) {
  const classes = useCreateVirtualMachineModalStyles()

  const availableVolumes = useMemo(
    () =>
      filterAvailableCreateVmVolumes({
        availableVolumes: availableVolumesRaw,
        sourceType: params.sourceType,
        selectedBootVolumes: params.volume,
      }),
    [availableVolumesRaw, params.sourceType, params.volume],
  )

  return (
    <div className={classes.fields}>
      <Info className={classes.info}>
        <div className={classes.infoContent}>
          <Text variant="caption1">Attach Additional Volumes</Text>
          <Text variant="body2">
            Only volumes with <b>available</b> status may be selected below.
          </Text>
        </div>
      </Info>
      <Text variant="subtitle2">Volume</Text>
      <ListTableField
        id="volume"
        data={availableVolumes}
        onReload={reloadAvailableVolumes}
        loading={loadingAvailableVolumes || updatingAvailableVolumes}
        columns={volumeColumns}
        onChange={getParamsUpdater('attachVolumes')}
        value={params.attachVolumes}
        uniqueIdentifier="id"
        searchTargets={['name', 'status', 'volume_type', 'description']}
        emptyText="No available volumes found"
        multiSelection
      />
    </div>
  )
}
